/* eslint-disable */
import "ol/ol.css";
import { Map, View, Overlay } from "ol";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
import { OSM } from "ol/source";
import { Vector as VectorSource } from "ol/source";
import { Feature } from "ol";
import { Point } from "ol/geom";
import { Style, Icon } from "ol/style";
import { fromLonLat } from "ol/proj";
//import { getCenter, getExtent } from 'ol/extent';

/**
 * Función para crear el mapa e insertarlo en el html
 *
 * @param {HTMLElement} targetElement
 * @returns {Map}
 */
export function createMap(targetElement) {
  const map = new Map({
    target: targetElement,
    layers: [
      new TileLayer({
        source: new OSM(),
      }),
    ],
    view: new View({
      center: [0, 0], // Centro por defecto, se actualizará más adelante
      zoom: 5, // Zoom por defecto, se actualizará más adelante
    }),
  });

  return map;
}

function getImagenPopUp(imagenes) {
  if (imagenes > 0) {
    const imagenEstablecimiento = imagenes.find(
      (imagen) => imagen.es_principal === 1
    );

    return imagenEstablecimiento;
  }
}

/**
 * Función para crear marcadores a partir de los datos
 *
 * @param {Map} map
 * @param {Array} alojamientosData
 * @param {Array} restaurantesData
 * @returns {Object} Un objeto que contiene:
 *                    - {Array} features: Array de características creadas para los marcadores.
 *                    - {VectorSource} vectorSource: La fuente vectorial que contiene todas las características
 */
let vectorSource = null;
let vectorLayer = null;
export function createMarkersJornadas(map, alojamientosData, restaurantesData) {
  const features = [];

  // Iconos para los tipos
  const alojamientoIcon = new Icon({
    src: "/iconos/icono_alojamiento.png", // Ruta al icono de alojamiento
    scale: 0.8,
    anchor: [0.5, 1],
  });

  const restauranteIcon = new Icon({
    src: "/iconos/icono_restaurante.png", // Ruta al icono de restaurante
    scale: 0.8,
    anchor: [0.5, 1],
  });

  if (alojamientosData) {
    // Crear features para alojamientos
    alojamientosData.forEach((item) => {
      const feature = new Feature({
        geometry: new Point(fromLonLat([item.longitud, item.latitud])),
        type: "alojamiento",
        name: item.nombre,
        address: item.direccion,
        city: item.localidad,
        img: item.imagen,
        nombre_seo_participante: item.nombre_seo_participante,
      });

      // Establecer el estilo con el icono de alojamiento
      feature.setStyle(
        new Style({
          image: alojamientoIcon,
        })
      );

      features.push(feature);
    });
  }
  if (restaurantesData) {
    // Crear features para restaurantes

    restaurantesData.forEach((item) => {
      const feature = new Feature({
        geometry: new Point(fromLonLat([item.longitud, item.latitud])),
        type: "restaurante",
        name: item.nombre,
        address: item.direccion,
        city: item.localidad,
        img: item.imagen,
        nombre_seo_participante: item.nombre_seo_participante,
      });

      // Establecer el estilo con el icono de restaurante
      feature.setStyle(
        new Style({
          image: restauranteIcon,
        })
      );

      features.push(feature);
    });
  }
  // Si ya existe la fuente, limpiar los features antiguos y agregar los nuevos
  if (vectorSource) {
    vectorSource.clear(); 
    vectorSource.addFeatures(features); 
  } else {
    // Si no existe, crea la fuente con los nuevos features
    vectorSource = new VectorSource({
      features: features,
    });

  }
  
  // Si ya existe la capa, no es necesario reemplazarla
  if (!vectorLayer) {
    vectorLayer = new VectorLayer({
      source: vectorSource,
    });
    
    //map.addLayer(vectorLayer); // Añade la capa al mapa la primera vez
  }

  map.addLayer(vectorLayer); 

  return { features, vectorSource };
}

/**
 * Función para crear marcadores a partir de los datos para un establecimiento
 *
 * @param {Map} map
 * @param {Array} establecimientoData
 * @returns {Object} Un objeto que contiene:
 *                    - {Array} features: Array de características creadas para los marcadores.
 *                    - {VectorSource} vectorSource: La fuente vectorial que contiene todas las características
 */
export function createMarkersEstablecimiento(map, establecimientoData) {
  const features = [];
  // Iconos para los tipos
  const alojamientoIcon = new Icon({
    src: "/iconos/icono_alojamiento.png", // Ruta al icono de alojamiento
    scale: 0.8,
    anchor: [0.5, 1],
  });

  const restauranteIcon = new Icon({
    src: "/iconos/icono_restaurante.png", // Ruta al icono de restaurante
    scale: 0.8,
    anchor: [0.5, 1],
  });

  // Si el establecimiento tiene imaǵenes cargadas se selecciona la imagen principal como campo imagen (para el popup)
  if (establecimientoData.imagenes > 0) {
    const imagenEstablecimiento = establecimientoData.imagenes.find(
      (imagen) => imagen.es_principal === 1
    );
    establecimientoData.imagen = imagenEstablecimiento.imagen;
  }

  // Crear features para un establecimiento

  const feature = new Feature({
    geometry: new Point(
      fromLonLat([establecimientoData.longitud, establecimientoData.latitud])
    ),
    type: establecimientoData.es_hotel != 0 ? "alojamiento" : "restaurante",
    name: establecimientoData.nombre,
    address: establecimientoData.direccion,
    city: establecimientoData.localidad,
    nombre_seo_participante: establecimientoData.nombre_seo_participante,
    img: establecimientoData.imagen
      ? establecimientoData.imagen
      : "/imagen_participante.jpg",
  });

  // Establecer el icono si es alojamiento o restaurante
  feature.setStyle(
    new Style({
      image:
        establecimientoData.es_hotel != 0 ? alojamientoIcon : restauranteIcon,
    })
  );

  features.push(feature);

  // Crear una fuente y capa vectorial
  const vectorSource = new VectorSource({
    features: features,
  });

  const vectorLayer = new VectorLayer({
    source: vectorSource,
  });

  // Añadir la capa vectorial al mapa
  map.addLayer(vectorLayer);

  return { features, vectorSource };
}

/**
 * Función que carga los datos desde un objeto
 *
 * @param {Object} data
 * @returns
 */
export function loadMapDataJornadas(data) {
  // Retornamos los datos de alojamientos y restaurantes

  return {
    alojamientos: data.alojamientos || [],
    restaurantes: data.restaurantes || [],
  };
}
// Función para cargar datos desde un objeto
export function loadMapDataParticipante(data) {
  // Retornamos los datos de alojamientos y restaurantes

  return {
    participante: data || [],
  };
}
// Función para crear el popup
export function createPopup(popupElement) {
  const popup = new Overlay({
    element: popupElement,
    positioning: "bottom-center",
    stopEvent: false,
    offset: [0, -15],
  });

  return popup;
}

/**
 *
 * @param {Map} map
 * @param {*} popup
 * @param {Function} callback
 */
export function addMapClickEvent(map, popup, callback) {
  map.on("singleclick", function (evt) {
    const feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
      return feature;
    });

    if (feature) {
      const properties = feature.getProperties();
      const coordinates = feature.getGeometry().getCoordinates();

      // Mostrar el popup en la ubicación del marcador
      popup.setPosition(coordinates);

      // Llamar al callback para actualizar el contenido del popup
      callback(properties);
    } else {
      // Ocultar el popup si no se hace clic en un marcador
      popup.setPosition(undefined);
    }
  });
}

/**
 * Ajusta varios puntos en el mapa
 *
 * @param {Map} map
 * @param {Feature} features
 */
export function fitMapToFeaturesJornadas(map, features) {
  if (features.length > 0) {
    const extent = features[0].getGeometry().getExtent().slice();
    features.forEach((feature) => {
      const geometry = feature.getGeometry();
      if (geometry) {
        const geomExtent = geometry.getExtent();
        extent[0] = Math.min(extent[0], geomExtent[0]);
        extent[1] = Math.min(extent[1], geomExtent[1]);
        extent[2] = Math.max(extent[2], geomExtent[2]);
        extent[3] = Math.max(extent[3], geomExtent[3]);
      }
    });
    map.getView().fit(extent, { padding: [50, 50, 50, 50], maxZoom: 18 });
  } else {
    // Si no hay features, establecer un centro y zoom por defecto
    map.getView().setCenter([0, 0]);
    map.getView().setZoom(10);
  }
}

// TODO VALORAR CREAR UN CAMPO EN EL FORMULARIO PARA ENVIAR ZOOMS PERSONALIZADOS
/**
 *
 * Centra en el mapa cuand solo hay un elemento
 * @param {Map} map
 * @param {Feature} feature
 */
export function centerMapEstablecimiento(map, feature) {
  const geometry = feature.getGeometry();
  const coordinates = geometry.getCoordinates();

  map.getView().setCenter(coordinates);

  map.getView().setZoom(12);
}
